import { Component, ElementRef, ViewChild, NgZone } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';
import { IonicPage, Platform, Content, Events } from 'ionic-angular';
import { WalletProvider } from '../../providers/wallet/wallet';
import { WalletDetails } from '../../model/myria/app/user';
import { SegmentProvider } from '../../providers/analytics/segment';
import { RouteProvider } from '../../providers/route/route';
import { LoggerProvider, LoggerEvent, LoggerLevel } from '../../providers/logger/logger';
import { AnalyticsEventType, AnalyticsPaymentMethodData, SegmentLocationNames, ContactModalReasons, DepositMethods, BannerType, CarouselCardType } from '../../model/types/analytics.const';
import { RecentData, Transaction, WalletTransaction, WalletTransactionStatus } from '../../model/myria/app/transaction';
import { LoadingProvider } from '../../providers/loading/loading';
import { ITabMenuItem, QRCodeInfo, QrCodeProvider, QrIDtype, QrScannerTab } from '../../model/models/wallet/wallet';
import { PinActionType } from '../../model/types/wallet-pin-action-type';
import { TranslateService } from "@ngx-translate/core";
//import { EventEmitterProxy } from 'ionic-angular/umd/components/content/content'; // removed to fix release build issue https://stackoverflow.com/a/55832943
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { RmtSnackbarComponent } from '../../components/rmt-snackbar/rmt-snackbar';
import { WalletStatus } from '../../model/types/wallet-status';
import { CustomersProvider } from '../../providers/myria/customer-provider/customers-provider';
import { AuthProvider } from '../../providers/authorization';
import { CallProvider } from '../../providers/call/call';
import { CARDSTATUS, WALLETTRANSACTIONPERPAGE} from '../../model/models/wallet/wallet-card';
import { WalletCardProvider } from '../../providers/wallet/wallet-card';
import { DeeplinkProvider } from '../../providers/marketing/deeplink';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { FeatureFlagTypes } from '../../model/types/feature-flag-types';
import { APP_CONFIG, Region } from '../../environment'
import { ALERT_TYPE, COUNTRY_SETTINGS, WALLET_ACTIVATION_RETVAL, KYC_ATTEMPT_STATUS, EVENTS_NAME } from '../../providers/myria/app-variables'
import { QrcodescannerProvider } from '../../providers/qrcodescanner/qrcodescanner';
import { WALLET_SERVICES } from '../../model/types/wallet';
import { CommonProvider } from '../../providers/common/common';
import { LoginProvider } from '../../providers/myria/login-provider';
import { INavInfo } from '../../model/models/layout/nav-info.interface';
import { HelpProvider } from '../../providers/help/help';
import { KYCProvider } from '../../providers/myria/kyc-provider';
import { PaymentMethodTypeID } from '../../model/types/payment-method-type';
import { OrderProvider } from '../../providers/order/order';
import { OnfidoProvider } from '../../providers/myria/onfido-provider';
import { SendFlowProvider } from '../../providers/send-flow/send-flow';

import { InAppMessage } from '../../model/api/iterables/iterables-inapp-response.entity.interface';
import { SLIDE_TYPE_ID } from '../activity/activity';
import { IterableInAppProvider } from '../../providers/marketing/iterable-inapp';
import { HttpProvider } from '../../providers/http/http';
import { RmtSlides } from '../../components/rmt-slides/rmt-slides';
import { IterableProvider } from '../../providers/marketing/iterable';
import { WalletVerificationStatus } from '../../model/types/wallet-verification-status';
import { StorageProvider } from '../../providers/storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { CustomerProvider } from '../../providers/customer/customer';
import { SocialProvider } from '../../providers/social/social';
import { WalletServicesProvider } from '../../providers/wallet-services/wallet-services';
import { WALLET_SERVICE_CATEGORIES } from '../../model/types/wallet-services-type';

const ID_PRE_EXPIRY_BANNER_DAYS = 29;
const ID_PRE_EXPIRY_BANNER_CAMPAIGN_ID = 'home_id_expiring_soon';

@IonicPage()
@Component({
  selector: 'wallet-home',
  templateUrl: 'wallet-home.html'
})
export class WalletHomePage {
  firstName: string;
  walletDetails: WalletDetails;
  allTransactions: WalletTransaction[] = [];
  completedTransactions: WalletTransaction[] = [];
  localWalletTransactions: WalletTransaction[] = [];
  newWalletTransaction: WalletTransaction = null;
  isTransactionsReady: boolean = true;
  isLoading: boolean = true;
  currentPage: number;
  qrCodeInfo: QRCodeInfo;
  walletItemButtonAction: Function;
  @ViewChild(Content)
  content: Content;
  headerElement;
  ionScrollSubscription;
  isBalanceLoading: boolean = false;
  isWalletDetailsLoading: boolean = true;
  isWalletTemporaryBlocked: boolean = false;
  isWalletComplainceBlocked: boolean = false;
  isUserWalletBlock: boolean = false;
  isWalletInActive: boolean = false;
  showManageCardLink: boolean = false;
  isDormantUser: boolean = false;
  blockedWalletActionTextKey: string  = "page.eWalletPage.resetPINButton";
  blockedUserAlertText;
  deepLinkGetRiaCardSubscribe;
  enableCardIssuance: boolean = false;
  virtualCardIssuance: boolean = false;
  physicalCardIssuance: boolean = false;
  isPlatformAndroid: boolean = false;
  isShowWalletBalance: boolean = true;
  isAfterRefresh: boolean = false;
  @ViewChild('header') header;
  location = 'Wallet Home';
  isEnableMobileTopup: boolean = false;
  walletCurrency: string;

  canShowCardsBanner: boolean = false;
  qrCodeImage: any;
  isQRLoading: boolean = false;
  cachedBalance: any = null; // last known balance from storage, shown until api/Wallet answers
  cachedCurrency: string = null;
  firstRefresh: boolean = true;
  isBalanceHidden: boolean = false;
  duitnowStaticQrPreloaded: boolean = false;
  isSN: boolean = false;
  isUserWalletFailedToCreated: boolean = false;
  isUserKyced: boolean = false;
  isCustomerIDExpired: boolean;
  isCustomerIDExpiringSoon: boolean = false;
  idPreExpiryBannerTracked: boolean = false;
  renderPendingOrderDetails: boolean = false;
  renderIncomingTranx: boolean = false;
  referAFriendAvailable: boolean = false;
  referralReward: string = '';
  canSwitchToSmallReferralBtn: boolean = false;
  onReferAFriendClick: any;
  pendingOrderMessage: string = "";
  pendingOrderEkycTitle: string = "";
  isPendingOrderExpired: boolean = false;
  pendingTranxAlerts: Array<any> = [];

  @ViewChild('slidesMessagesComponent') slidesMessagesComponent;
  clickSlideClose: any;
  lockedScroll: boolean = false;
  hasInAppMessages: boolean = false;
  inAppMessages: InAppMessage[] = [];
  recentData = new RecentData();
  pinCreated: boolean = true;
  alertStyles = {'margin-left': '0px', 'margin-right': '0px', 'margin-top': '16px', 'margin-bottom': '16px'};
  isCDMDepositEnabled: boolean = false;

  toggleValue: number = 1;
  isWalletToggle: boolean = true;
  isRemittanceToggle: boolean = false;
  remittanceOnlyTransactions: Transaction[] = [];
  allRemittanceOnlyTransactions: Transaction[] = [];
  showTransferStatusWidget: boolean = false;
  toRenderInfiniteScroll: boolean = false;
  toggleButtonList = [
    { id : 1 , labelName : 'global.eWalletNav'},
    { id : 2 , labelName : 'page.eWalletPage.remitTabLabel'},

  ]
  private intervalWalletEFTDownCheck: any;
  private resumeSubscription: any;
  private isRefreshingBalance: boolean = false;

  private walletBalanceRefreshHandler = () => this.ngZone.run(() => this.refreshWalletData());

  constructor(
    private analytics: SegmentProvider,
    private elementRef: ElementRef,
    private routeProvider: RouteProvider,
    private walletProvider: WalletProvider,
    private loadingProvider: LoadingProvider,
    private customersProvider: CustomersProvider,
    private authProvider: AuthProvider,
    private call: CallProvider,
    private platform: Platform,
    private translate: TranslateService,
    private walletCardProvider: WalletCardProvider,
    private deeplinkProvider: DeeplinkProvider,
    public utilsProvider: UtilsProvider,
    private qrcodescannerProvider: QrcodescannerProvider,
    private commonProvider: CommonProvider,
    private loginProvider: LoginProvider,
    private helpProvider: HelpProvider,
    private kycProvider: KYCProvider,
    private orderProvider: OrderProvider,
    private onfidoProvider: OnfidoProvider,
    private sendFlowProvider: SendFlowProvider,
    private iterable: IterableProvider,
    private iterableInAppProvider : IterableInAppProvider,
    private httpProvider: HttpProvider,
    private storageProvider: StorageProvider,
    private customerProvider: CustomerProvider,
    private socialProvider: SocialProvider,
    private events: Events,
    private ngZone: NgZone,
    private walletServicesProvider: WalletServicesProvider,
  ) {
    this.allTransactions = [];
    this.completedTransactions = [];
    // cache walletDetails
    const cachedWallet: any = this.walletProvider.walletUser;
    if (cachedWallet && cachedWallet.Value)
      this.walletDetails = cachedWallet.Value;
    // list visible and the refresh happens in the background, instead of resetting to a skeleton.
    const cachedTransactions: any = this.walletProvider.transcationsListHomePage;
    if (cachedTransactions && cachedTransactions.length)
      this.groupWalletTransactions(cachedTransactions);
    // after a fresh login show the last known balance and QR while api/Wallet and the QR call refresh them.
    if (this.walletProvider.walletQRCodeString)
      this.qrCodeImage = this.walletProvider.walletQRCodeString;
    if (!this.walletDetails)
      this.walletProvider.getCachedWalletBalance().then((cached) => {
        if (cached) {
          this.cachedBalance = cached.balance;
          this.cachedCurrency = cached.currency;
        }
      });
    this.isShowWalletBalance = this.walletProvider.isShowWalletBalance;
    this.isSN = this.commonProvider.isSN();
    this.isUserWalletFailedToCreated = (!this.walletProvider.hasWallet() && this.isSN) ? true : false; //// create wallet msg if EFT failed to create wallet at time of refister account.
    this.clickSlideClose = (slideMessage) => this.clickCloseSlide(slideMessage)
    this.onReferAFriendClick = () => this.onReferAFriend();
    this.firstRefresh = this.walletProvider.isFirstRefresh();
  }

  async ionViewWillEnter() {
    // Server flag is the real gate; the APP_CONFIG value is a QA override only reachable from the debug menu, so it is honored only in debug builds.
    this.showTransferStatusWidget = (await this.utilsProvider.getFeatureFlagData(FeatureFlagTypes.TransferStatusWidgetEnabled)) === true
      || (APP_CONFIG.showDebug && APP_CONFIG.showTransferStatusWidget);
    this.toRenderInfiniteScroll = APP_CONFIG.region.region === Region.MY || APP_CONFIG.region.region === Region.SN;
    this.isPlatformAndroid = this.platform.is('android');
    this.firstName = this.authProvider.getUserFirstName();
    this.checkReferAFriendAvailability();

    // For MY only, preload the static DuitNow QR in the background so the QR scanner page opens instantly.
    if (APP_CONFIG.region.region === Region.MY && !this.duitnowStaticQrPreloaded) {
      this.walletProvider.preloadDuitnowStaticQRImage().then((settled) => {
        this.duitnowStaticQrPreloaded = settled;
      });
    }

    // Warm the bill pay billers cache in the background so the billers page opens instantly.
    if (APP_CONFIG.region.walletServices.some(service => service.type === WALLET_SERVICES.BILLPAYMENTS)) {
      this.prefetchBillers();
    }
    // Same for the airtime operator lookup of the user's prefilled mobile number.
    if (APP_CONFIG.region.walletServices.some(service => service.type === WALLET_SERVICES.AIRTIME)) {
      this.walletServicesProvider.prefetchProvider(this.customerProvider.getUserMobileNumber(true));
    }

    // Skip doRefresh if returning from specific tabs
     window.requestAnimationFrame(() => {
      const lastPage = this.routeProvider.getLastActivePage();
      if (
        lastPage !== this.routeProvider.pages.TabMorePage.page &&
        lastPage !== this.routeProvider.pages.TabSendMorePage.page
      ) {
        this.doRefresh();
      }
    });

     this.isWalletDetailsLoading = !this.walletDetails;

    // Country settings
    // OM-15924 | Performance optimization | using hasCountrySettingByPromise instead of multiple subscriptions to hasCountrySetting
    const regionId = APP_CONFIG.region.regionId;

    try {
      this.isLoading = true;
      this.isUserKyced = await this.kycProvider.isVeriffUserKyced(this.firstRefresh);
      // TODO: Optimisation: If firstload from signin, pass true once BE ads expirationDate to the KYC object in the signin response
      await this.setCustomerIDExpiryStatus();
      const appMessagesPromise = this.getAppMessages();

      if (this.isSN) {
        const isPendingOrderExpired = await this.walletProvider.isPendingOrderExpired();
        if (isPendingOrderExpired) {
          this.isPendingOrderExpired = true;
        } else {
          const pendingOrderDetails = await this.walletProvider.fetchPendingOrderDetails();
          if (pendingOrderDetails) {
            this.pendingOrderMessage = pendingOrderDetails.pendingOrderMessage;
            this.pendingOrderEkycTitle = pendingOrderDetails.pendingOrderEkycTitle;
            const isKycInProgress = HttpProvider.user && HttpProvider.user.IdentityVerification && HttpProvider.user.IdentityVerification.Status === KYC_ATTEMPT_STATUS.IN_PROGRESS;
            // Expiredd ID demotess the wallet to Litee, so treat these users as non-KYC for pending-transfer slidee routing (show the eKYC upgrade CTA, not the incoming-tranx info slide).
            const isEffectivelyKyced = this.isUserKyced && !this.isCustomerIDExpired;
            this.renderIncomingTranx = pendingOrderDetails.renderPendingOrderDetails && (isEffectivelyKyced || isKycInProgress);
            this.renderPendingOrderDetails = pendingOrderDetails.renderPendingOrderDetails && !isEffectivelyKyced && !isKycInProgress;
          }
        }

        this.updateSlideMessages(null);
      }

      await this.walletProvider.getWalletLimit();
      this.isLoading = false;

      this.walletDetails = await this.walletProvider.getWalletDetails();
      this.loginProvider.walletStatus = await this.walletProvider.getWalletStatusAsString(); // setting the wallet status here to pass this into identify traits. cann't get this status in login provider because of circular dependency.

      // Check in parallel if there is a country settings for mobile top-up and card issuance
      const [mobileTopup, cardIssuance, isCDMEnabled] = await Promise.all([
        this.utilsProvider.hasCountrySettingByPromise(regionId, COUNTRY_SETTINGS.EENABLE_MOBILE_TOP_UP),
        this.utilsProvider.hasCountrySettingByPromise(regionId, COUNTRY_SETTINGS.ENABLE_RIA_PRE_PAID_CARDS),
        this.utilsProvider.hasCountrySettingByPromise(regionId, COUNTRY_SETTINGS.DISABLE_CDM_DEPOSIT)
      ]);

      this.isEnableMobileTopup = this.utilsProvider.normalizeToBoolean(mobileTopup);
      this.enableCardIssuance = this.utilsProvider.normalizeToBoolean(cardIssuance);
      this.isCDMDepositEnabled = this.utilsProvider.normalizeToBoolean(isCDMEnabled);

      if (this.enableCardIssuance) {
        // Check in parallel if there is a country settings for the physical and virtual cards
        try {
          const [physicalCardIssuance, virtualCardIssuance] = await Promise.all([
            this.utilsProvider.hasCountrySettingByPromise(regionId, COUNTRY_SETTINGS.ENABLE_PHYSICAL_RIA_PRE_PAID_CARD_ISSUANCE),
            this.utilsProvider.hasCountrySettingByPromise(regionId, COUNTRY_SETTINGS.ENABLE_VIRTUAL_RIA_PRE_PAID_CARD_ISSUANCE)
          ]);
          this.physicalCardIssuance = this.utilsProvider.normalizeToBoolean(physicalCardIssuance);
          this.virtualCardIssuance = this.utilsProvider.normalizeToBoolean(virtualCardIssuance);
        } catch (err) {
          LoggerProvider.exception(this, err, LoggerEvent.Wallet, "Failed to load wallet and physical/virtual card settings");
        }
      } else {
        this.checkAndAssignCanShowCardBanner();
      }


      if(!this.isUserWalletFailedToCreated){
        this.walletCurrency = this.walletDetails.WalletCurrencyCode;
        this.isWalletDetailsLoading = false;
      } else{
        this.isBalanceLoading = false;
        this.isWalletDetailsLoading = false;
        this.isTransactionsReady = false;
        this.walletCurrency = APP_CONFIG.region.defaultCurrencyFrom;
        this.blockedUserAlertText = this.translate.instant('page.walletHomepage.createWalletErrorMessage');
        this.blockedWalletActionTextKey = this.translate.instant('page.walletHomepage.tapToTryAgain');
        this.iterable.enableAutoDisplay();
      }

      //set interval to check wallet status if EFT wallet down
      if(this.walletDetails && this.walletProvider.isEFTWalletDown){
        this.intervalWalletEFTDownCheck = setInterval(async () => {
          this.walletDetails = await this.walletProvider.getWalletDetails(true);
          if(this.walletDetails && !this.walletProvider.isEFTWalletDown){
            this.getQRCodeInfo()
            clearInterval(this.intervalWalletEFTDownCheck);
          }
        }, APP_CONFIG.eftDownIntrvalCall);
      }

      this.isLoading = false;
      
      // canShowCardsBanner is otherwise only set by doRefresh, which can finish after this point.
      this.checkAndAssignCanShowCardBanner();
      this.updateSlideMessages(null);


      if(this.isSN === true)
        this.logWalletAccessedEvent();

      await appMessagesPromise;
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "Couldn't get the wallet details")
      this.walletProvider.showGenericError();
      this.isWalletDetailsLoading = false;
      this.isLoading = false;
    }
  }

  async init(refresh=false) {
    if(!this.isUserWalletFailedToCreated){
      this.currentPage = 1;
      await this.getWalletTransactions(this.currentPage, refresh)
    }
  }

  async doRefresh(refresher?) {
    if(!this.isUserWalletFailedToCreated){
      let refreshUser = true;
      if (this.firstRefresh)
        refreshUser = false;

      this.isAfterRefresh = true;
      this.isLoading = true;
      this.isBalanceLoading = this.firstRefresh;

      const promises = [];
      const idExpiryStatusPromise = this.setCustomerIDExpiryStatus();
      promises.push(idExpiryStatusPromise);
      promises.push(this.getWalletDetails(refreshUser));
      promises.push(this.getQRCodeInfo());
      promises.push(this.init(refreshUser));
      if (!this.firstRefresh)
        promises.push(idExpiryStatusPromise.then(() => this.getAppMessages()));
      await Promise.all(promises);
      if(refresher){
        refresher.complete();
      }
      this.walletProvider.setFirstRefresh(false);// put it at provider level to prevent clear var when page is readded by set root
      this.firstRefresh = this.walletProvider.isFirstRefresh();
    } else if(refresher){
      await this.loginProvider.getUserAsync(true);
      this.isUserWalletFailedToCreated = (!this.walletProvider.hasWallet() && this.isSN) ? true : false;
      if(!this.isUserWalletFailedToCreated){
        this.walletDetails = await this.walletProvider.getWalletDetails();
        this.getQRCodeInfo()
      }
      refresher.complete();
    }
  }




  checkAndAssignCanShowCardBanner() {
    this.canShowCardsBanner = false;
    let inActiveCards = [];
    if (this.walletDetails && this.walletDetails.Cards) {
      inActiveCards = this.walletDetails.Cards.filter(card => {
        return (card.Status != CARDSTATUS.ACTIVE && card.Status != null);
      });
      if(inActiveCards.length > 0){
        this.canShowCardsBanner = true;
      }
    }
  }

  async ionViewDidEnter() {
    this.routeProvider.waitForTransitions();
    this.ionScrollSubscription = this.content.ionScroll.subscribe(this.onScroll);
    this.headerElement = this.elementRef.nativeElement.querySelector('.screen-title');

    // Refresh the wallet when WALLET_BALANCE_REFRESH event is triggered
    this.resumeSubscription = this.platform.resume.subscribe(this.walletBalanceRefreshHandler);
    this.events.subscribe(EVENTS_NAME.WALLET_BALANCE_REFRESH, this.walletBalanceRefreshHandler);

    // Preload recent and phone contacts for the recipient list in the background. SN lands here without TabsHomePage,
    // and both are cached, so re-entering home doesn't load them again.
    if (this.walletProvider.hasWallet()) {
      this.walletProvider.getCachedRecentContacts();
      this.walletProvider.preloadPhoneContacts();
    }
  }

  ionViewDidLeave() {
    if(this.ionScrollSubscription)
      this.ionScrollSubscription.unsubscribe();
    if(this.resumeSubscription)
      this.resumeSubscription.unsubscribe();
    this.events.unsubscribe(EVENTS_NAME.WALLET_BALANCE_REFRESH, this.walletBalanceRefreshHandler);
  }

  // Background refresh of wallet details (available balance) and transactions
  async refreshWalletData() {
    if(this.isUserWalletFailedToCreated || this.isRefreshingBalance)
      return;
    try {
      this.isRefreshingBalance = true;
      await this.getWalletDetails(true);
      await this.init(true);
    } finally {
      this.isRefreshingBalance = false;
    }
  }

  async prefetchBillers() {
    const walletDetails = await this.walletProvider.getWalletDetails();
    const walletCurrencyCode = (walletDetails && walletDetails.WalletCurrencyCode)
      ? walletDetails.WalletCurrencyCode
      : APP_CONFIG.region.defaultCurrencyFrom;
    await this.walletServicesProvider.getBillers(walletCurrencyCode, WALLET_SERVICE_CATEGORIES.BILL_PAY);
  }

  async getWalletDetails(refresh: boolean = false) {
    try {
      // Fetch wallet details (in background if called from modal)
      this.walletDetails = await this.walletProvider.getWalletDetails(refresh);

      this.isWalletDetailsLoading = false;

      if (!this.walletDetails) {
        if (!this.walletProvider.isWalletRetrieveFail) {
          this.walletProvider.showGenericError();
        }
        return;
      }

      if (this.walletDetails) {
        if(APP_CONFIG.region.region === Region.SN && await this.walletProvider.isWalletBlacklistedOrPermanentBlocked()){
          this.walletProvider.showWalletBlockedPage();
          return;
        }

        const status = this.walletDetails.Status;
        this.isWalletTemporaryBlocked = status === WalletStatus.TemporaryBlocked;
        this.isWalletComplainceBlocked = status === WalletStatus.ComplianceBlocked;
        this.isDormantUser = this.walletDetails.IsDormant;
        this.isWalletInActive = status === WalletStatus.Inactive;

        this.isWalletTemporaryBlocked = (status === WalletStatus.TemporaryBlocked);
        this.isWalletComplainceBlocked = (status === WalletStatus.ComplianceBlocked);
        this.isDormantUser = this.walletDetails.IsDormant;
        this.isWalletInActive = (status === WalletStatus.Inactive);
        this.isUserWalletBlock = (this.isWalletComplainceBlocked || this.isWalletTemporaryBlocked || this.isDormantUser || this.isWalletInActive);

        // If the user exited the app after activating wallet but not setting the pin
        if (!this.walletDetails.PinCreated && this.walletDetails.Status === WalletStatus.Active) {
          this.pinCreated = false;
          this.blockedUserAlertText = this.translate.instant('page.settingsPage.need6DigitPasscodeBody');
          this.blockedWalletActionTextKey = this.translate.instant('page.eWalletPage.activateWalletButton');
        }

        if(this.isUserWalletBlock){
          this.blockedUserAlertText = (this.isDormantUser) ? this.translate.instant('page.eWalletPage.walletInactivityText') : (this.isWalletInActive) ? this.translate.instant('page.settingsPage.need6DigitPasscodeBody') : this.translate.instant('page.eWalletPage.accountLockedErrorMessage');
          if(this.isWalletTemporaryBlocked){
            if(this.isSN === true){
              this.blockedWalletActionTextKey = this.translate.instant('page.eWalletPage.customerServiceButton');
            } else{
              this.blockedWalletActionTextKey = this.translate.instant('page.eWalletPage.resetPINButton');
            }
          } else if(this.isWalletInActive){
            this.blockedWalletActionTextKey = this.translate.instant('page.eWalletPage.activateWalletButton');
          } else {
            this.blockedWalletActionTextKey = this.translate.instant('page.eWalletPage.customerServiceButton');
          }
        }
      }

      this.checkAndAssignCanShowCardBanner();
      this.isBalanceLoading = false;
      this.checkAndSubscribeRiaCardDeepLink();

    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "Couldn't update the wallet details");
      this.walletProvider.showGenericError();
      this.isWalletDetailsLoading = false;
    }
  }


  async getWalletTransactions(page: number,refresh=false): Promise<any> {
    try {
      // since it's slow we shouldn't show loading again when we refresh it and do it in the background (i.e. closing check prices modal)
      const transactionsPromise = this.walletProvider.getWalletTransactionHomePage(
        page,
        WALLETTRANSACTIONPERPAGE.HOME,
        refresh
      );
      const remittancePromise = this.customersProvider.getTransactionsGroupedByStatus(0);

      transactionsPromise
        .then(transactions => {
          if (transactions) {
            if (page === 1) {
              this.allTransactions = [];
              if (!this.walletProvider.isWalletTransactionsLoadedLogged) {
                this.analytics.trackEvent({
                  eventName: AnalyticsEventType.WalletTransactionsLoaded,
                  analyticsData: {}
                });
                this.walletProvider.isWalletTransactionsLoadedLogged = true;
              }
            }
            this.groupWalletTransactions(transactions);
            this.isLoading = false;
          } else {
            RmtPopupComponent.showExceptionWithLogTranslation(
              this,
              {},
              'global.myRia.jsonContent.OopsInfo'
            );
          }
        })
        .catch(ex => {
          RmtPopupComponent.showExceptionWithLogTranslation(
            this,
            ex,
            'global.myRia.jsonContent.OopsInfo'
          );
        });

      remittancePromise
        .then(allRemittanceOnlyTransactions => {
          this.allRemittanceOnlyTransactions = allRemittanceOnlyTransactions;
          this.remittanceOnlyTransactions = Array.isArray(this.allRemittanceOnlyTransactions)
            ? this.allRemittanceOnlyTransactions.slice(0, 4)
            : [];
        })
        .catch(ex => {
          RmtPopupComponent.showExceptionWithLogTranslation(
            this,
            ex,
            'global.myRia.jsonContent.OopsInfo'
          );
        });
    } catch (ex) {
      RmtPopupComponent.showExceptionWithLogTranslation(this, ex, 'global.myRia.jsonContent.OopsInfo');
    }
  }

  groupWalletTransactions(transactions: WalletTransaction[]) {
    this.allTransactions.push(...transactions)
    this.completedTransactions = this.allTransactions.filter(transaction => transaction.TransactionStatus === WalletTransactionStatus.Pending || transaction.TransactionStatus === WalletTransactionStatus.Completed || transaction.TransactionStatus === WalletTransactionStatus.Failed);
    this.isTransactionsReady = (this.completedTransactions.length > 0) ? true : false;
  }

  async getMoreWalletTransactions(scroll: any) {
    this.updateCurrentPage();
    const transactions = await this.getWalletTransactions(this.currentPage,true);
    this.groupWalletTransactions(transactions);
    scroll.complete();
  }

  onScroll(scrollInfo: any) {
    if (this && this.header && this.header.appbar)
      this.header.appbar.canSwitchToSmallReferralBtn = scrollInfo.scrollTop > 0;
    if (!this || !this.walletDetails || !this.headerElement || this.isBalanceHidden)
      return
    if (scrollInfo.scrollTop >= 60) { // when scrollTop = 60 the balance label is disappeared
      this.headerElement.style.opacity = 1;
      this.headerElement.style.paddingLeft = "35px";
    } else {
      this.headerElement.style.opacity = 0;
    }
  }

  updateCurrentPage() {
    this.currentPage += 1
  }

  getIconFor(transaction: WalletTransaction): string {
    return this.walletProvider.getIconFor(transaction);
  }

  WalletBalanceDetails() {
    this.routeProvider.openActionSheet(this.routeProvider.pages.WalletBalanceInfoPage, { walletDetails: this.walletDetails })
  }

  deposit() {
    this.analytics.trackEvent({ eventName: AnalyticsEventType.DepositAccessed, analyticsData: { location: this.location } });

    const items: ITabMenuItem[] = [
      {
        label: this.translate.instant('page.sendMoneyPaymentPage.eWalletCDM.Header'),
        imgUrl: 'assets/icons/cash_pickup_delivery.svg',
        action: () => this.payAtCDM(),
        disable: !this.isCDMDepositEnabled,
        greyedOut: !this.isCDMDepositEnabled,
      },
      {
        label: this.translate.instant('page.sendMoneyPaymentPage.eWalletRiaStoreText'),
        subtitle: this.translate.instant('page.eWalletPage.RiaLocationDescription'),
        imgUrl: 'assets/icons/pay_at_ria_gray.svg',
        action: () => this.payOnStore()
      },
      {
        label: this.translate.instant('page.sendMoneyPaymentPage.eWalletJomPayText'),
        subtitle: this.translate.instant('page.eWalletPage.bankAccountDescription'),
        imgUrl: 'assets/icons/jompay_gray.svg',
        action: () => this.payWithJomPay()
      }
    ];

    const params = {
      title: this.translate.instant('page.sendMoneyPaymentPage.eWalletDepositTitle'),
      items
    };
    this.routeProvider.openActionSheet(this.routeProvider.pages.TabMenuPage,params);

  }
  async payOnStore() {
    this.trackDeposit(DepositMethods.RiaLocation);
    this.routeProvider.openModal(this.routeProvider.pages.WalletDepositLocationGuidePage, { walletNumber: this.walletDetails.WalletNumber });
  }
  async payWithJomPay() {
    this.trackDeposit(DepositMethods.JomPay);
    this.routeProvider.openModal(this.routeProvider.pages.WalletDepositJomPayPage);
  }
  async payAtCDM() {
    this.trackDeposit(DepositMethods.CashDepositMachine);
    this.routeProvider.openModal(this.routeProvider.pages.CDMDepositPage, {customerID: this.walletDetails.CustomerId});
  }

  withdraw() {
    const items = [
      {
        label: this.translate.instant('page.eWalletPage.RiaLocationTitle'),
        subtitle: this.translate.instant('page.eWalletPage.RiaLocationDescription'),
        imgUrl: 'assets/icons/wallet_ria_location_gray.svg',
        action: () => {
          this.routeProvider.setRoot(
            this.routeProvider.pages.WalletWithdrawStepsPage,
            { actionType: PinActionType.Withdraw, WalletDetails: this.walletDetails }
          );
        },
      },
      {
        label: this.translate.instant('page.eWalletPage.bankAccountTitle'),
        subtitle: this.translate.instant('page.eWalletPage.bankAccountDescription'),
        imgUrl: 'assets/icons/wallet_back_account_gray.svg',
        action: () => this.loadExistBankAccounts(),
      }
    ];

    const params = {
      title: this.translate.instant('page.activityPage.eWalletWithdrawalLabel'),
      items,
    };

    this.routeProvider.openActionSheet(this.routeProvider.pages.TabMenuPage, params);
  }

  async pay() {
    try {
      let canShowLogosOnQRScanner = APP_CONFIG.region.canShowLogosOnQRScanner;
      let barcodeData = await this.qrcodescannerProvider.initializeAndOpenQRScanner(PinActionType.Pay, false, canShowLogosOnQRScanner);
      if(barcodeData !== null && barcodeData !== ""){
        LoggerProvider.info(this, 'Scanning Pay with QR Code');
        this.processQrCode(barcodeData)
      } else {
        this.walletProvider.showQRGenericError();
      }
    } catch (ex) {
        LoggerProvider.info(this, 'scanner closed or permission denied for QR Code');

    }
  }

  async onResumeCallBack(){
    await this.pay();
  }

  async processQrCode(barcodeData) {
    if (!barcodeData) return;
    this.loadingProvider.show();
    this.qrCodeInfo = await this.walletProvider.validateQRCode(barcodeData.barCode);
    this.loadingProvider.hide();
    // Ria Store QR is ONLY for Withdawal as confirmed by Joanne
    const isRiaAgentQr = this.qrCodeInfo
      && this.qrCodeInfo.QrCodeProvider === QrCodeProvider.Ria
      && this.qrCodeInfo.IdType === QrIDtype.RiaStore;
    if (isRiaAgentQr && barcodeData.actionType === PinActionType.Pay) {
      this.walletProvider.showWithdrawalQRPrompt(this.walletDetails);
      return;
    }
    // MY: Ria merchant QR payments are blocked when country setting 49017 is disabled (OM-21592)
    const isRiaMerchantQr = this.qrCodeInfo
      && this.qrCodeInfo.QrCodeProvider === QrCodeProvider.Ria
      && this.qrCodeInfo.IdType === QrIDtype.Merchant
      && !this.qrCodeInfo.ReferenceNo;
    if (isRiaMerchantQr && barcodeData.actionType === PinActionType.Pay && !this.isSN) {
      this.loadingProvider.show();
      const isRetailPaymentEnabled = await this.walletProvider.isRetailPaymentEnabledForCountry();
      this.loadingProvider.hide();
      if (!isRetailPaymentEnabled) {
        this.walletProvider.showRetailPaymentUnavailablePrompt(() => this.pay());
        return;
      }
    }

    // Check if scanned code is DuitNow Or EFT/RiaQR
    if ((this.qrCodeInfo) && (this.qrCodeInfo.ProxyNumber || this.qrCodeInfo.ReferenceNo)) {
      if (String(this.qrCodeInfo.FeeAmount) === "" || this.qrCodeInfo.FeeAmount <= 0) {
        this.qrCodeInfo.FeeAmount = 0.00;
      }
      // Fire fees prefetchh in parallel with setRoot so it's in-flight while the next page mounts
      if (this.isSN && this.qrCodeInfo.TransactionAmount) {
        const prefetchAmount = parseFloat(this.qrCodeInfo.TransactionAmount);
        const prefetchType = this.walletProvider.deriveQrTransactionType(this.qrCodeInfo, barcodeData.actionType);
        this.walletProvider.prefetchFees(prefetchAmount, prefetchType);
      }
      this.routeProvider.setRoot(this.routeProvider.pages.WalletWithdrawOrPaymentPage, { showBack: true, actionType: barcodeData.actionType, QRCodeInfo: this.qrCodeInfo, WalletDetails: this.walletDetails });
    } else {
      this.walletProvider.showQRGenericError();
      return;
    }
  }

  onResetPinClick(){
    this.routeProvider.openModal(this.routeProvider.pages.VerifyIdentityPage, { actionType: PinActionType.ResetPIN })
  }

  async onTransactionDetailsClick(transaction) {
    await this.walletProvider.onTransactionDetailsClick(transaction);
  }

  onBlockedActionClick(){
    if (!this.pinCreated) {
      this.walletProvider.setActiveWalletPin();
      return;
    }
    if(this.isWalletTemporaryBlocked){
      if(this.isSN === true){
        this.helpProvider.openHelp();
      } else{
        this.onResetPinClick();
      }
    }else if(this.isWalletComplainceBlocked){
      this.call.callCustomerService(SegmentLocationNames.Wallet, ContactModalReasons.RiaCardBlockedByCompliance);
    }else if(this.isDormantUser){
      this.walletCardProvider.accountLockedModalAlert(false);
    } else if(this.isUserWalletFailedToCreated){
      this.tryAgainActivCreateWallet();
    }
  }

  async loadExistBankAccounts(){
    this.analytics.trackEvent({ eventName: AnalyticsEventType.WithdrawalAccessed, analyticsData: {
          location: "Wallet",
          method: AnalyticsPaymentMethodData.BankAccount
         } });
    this.walletProvider.setForceReloadAccountsList(true);
    this.routeProvider.openModal(this.routeProvider.pages.WalletToBankAccountsListPage);
  }

  onClickSeeAll(isRemTab = false){
    this.routeProvider.openModal(this.routeProvider.pages.WalletAllTransactionsPage,{ walletDetails: this.walletDetails, toggleVal: isRemTab ? 2 : 1 });
  }

  checkAndSubscribeRiaCardDeepLink(){
    this.utilsProvider.hasCountrySetting(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.ENABLE_RIA_PRE_PAID_CARDS)
    .subscribe(enableCardIssuance => {
      if(enableCardIssuance == 1 && !this.isUserWalletBlock){
        this.enableCardIssuance = true;
        if(!this.deepLinkGetRiaCardSubscribe){
          this.deepLinkGetRiaCardSubscribe = this.deeplinkProvider.deeplinkGetRiaCardNotifications.subscribe((value) => {
            if(this.utilsProvider.normalizeToBoolean(value)) {
              let lastActivePage = this.routeProvider.getLastActivePage();
              if(lastActivePage !== this.routeProvider.pages.CardApplyProcess.page){
                this.routeProvider.openModal(this.routeProvider.pages.CardApplyProcess);
              }
              this.deeplinkProvider.setDeeplinkGetRiaCardNotifications(false);
            }
          });
        }
      }
    });
  }

  airTime(){
    this.analytics.trackEvent({ eventName: AnalyticsEventType.AirtimeAccessed, analyticsData: { location: "Home" , country: APP_CONFIG.region.defaultCountryFrom}});
    if (this.isSN) {
      this.routeProvider.push(this.routeProvider.pages.MobileTopUpNumberPage);
    } else {
      this.openAirtimeActionSheet()
    }
  }

  openMore(){
    let moreOptions = APP_CONFIG.region.walletServices.find(fieldValue => {return fieldValue.type == "more"});
    if(moreOptions){
      moreOptions = moreOptions.options;
      let params = {
        title:this.translate.instant('global.moreNav'),
        callBack:(service) =>{
          this.onWalletServiceClick(service);
        },moreOptions
      };
      this.routeProvider.openActionSheet(this.routeProvider.pages.WalletActionsMorePage,params);
    }
  }

  onWalletServiceClick(service){
    switch (service.type) {
      case WALLET_SERVICES.SEND:
        this.onSendClick(service);
        break;
      case WALLET_SERVICES.CARD:
        this.openCardSelectionPage();
        break;
      case WALLET_SERVICES.AIRTIME:
        this.airTime();
        break;
      case WALLET_SERVICES.DEPOSIT:
        this.deposit();
        break;
      case WALLET_SERVICES.WITHDRAW:
        this.withdraw();
        break;
      case WALLET_SERVICES.BILLPAYMENTS:
        this.openBillPayment();
        break;
      case WALLET_SERVICES.RECEIVE:
        this.getReceivePage();
        break;
      case WALLET_SERVICES.MORE:
        this.openMore();
        break;
    }
  }

  onCardBannerSelected(){
    this.openCardSelectionPage();
  }

  openCardSelectionPage(){
    this.routeProvider.openModal(this.routeProvider.pages.CardSelectionPage, { isShowBack: false });
  }

  onQRcodeClick(){
    this.analytics.trackEvent({eventName: AnalyticsEventType.QRScannerAccessed, analyticsData: {
      country: APP_CONFIG.region.defaultCountryFrom
    }});

    // Only show scanner access modal for SN userss
    if (this.isSN) {
      this.showScannerAccessModal();
    } else {
      this.pay();
    }
  }

  async showScannerAccessModal() {
    const canShowLogosOnQRScanner = APP_CONFIG.region.canShowLogosOnQRScanner;
    const isSN = this.commonProvider.isSN();
    let selectedAction = '';

    const params = {
      ...this.routeProvider.pages.WalletScannerAccessModal.params,
      // After merging with the new QR Scanner modal, it was breaking the new QR Scanner ppagee, hence avoid opening scanner from inside the modal callbacks
      primaryButtonAction: async (_routeProvider, modalInstance) => {
        selectedAction = 'pay';
        modalInstance.viewCtrl.dismiss();
      },
      secondaryButtonAction: async (_routeProvider, modalInstance) => {
        selectedAction = 'withdraw';
        modalInstance.viewCtrl.dismiss();
      },
      tertiaryAction: (_routeProvider, modalInstance) => {
        selectedAction = 'myqr';
        modalInstance.viewCtrl.dismiss();
      },
      dismissFromPrimary: false,
      dismissFromSecondary: false,
    };

        this.routeProvider.openActionSheetNew(this.routeProvider.pages.WalletScannerAccessModal, params, async () => {
      if (!selectedAction) return;

      try {
        if (selectedAction === 'pay') {
          const barcodeData = await this.qrcodescannerProvider.initializeAndOpenQRScanner(
            PinActionType.Pay,
            false,
            canShowLogosOnQRScanner,
            true,
            QrScannerTab.Pay
          );
          if (barcodeData) {
            this.processQrCode(barcodeData);
          }
        } else if (selectedAction === 'withdraw') {
          const barcodeData = await this.qrcodescannerProvider.initializeAndOpenQRScanner(
            PinActionType.Withdraw,
            false,
            canShowLogosOnQRScanner,
            true,
            isSN ? QrScannerTab.Withdraw : QrScannerTab.Pay
          );
          if (barcodeData) {
            this.processQrCode(barcodeData);
          }
        } else if (selectedAction === 'myqr') {
          await this.qrcodescannerProvider.initializeAndOpenQRScanner(
            PinActionType.Pay,
            false,
            canShowLogosOnQRScanner,
            true,
            isSN ? QrScannerTab.MyRiaQR : QrScannerTab.Withdraw
          );
        }
      } catch (ex) {
          LoggerProvider.info(this, 'scanner closed or permission denied for QR Code');

      }
    });
  }


  // live wallet details win; the cached balance only fills the gap until api/Wallet answers.
  get hasBalanceToShow(): boolean {
    return !!this.walletDetails || (this.cachedBalance !== null && this.cachedBalance !== undefined);
  }

  get displayBalance(): any {
    if (this.walletDetails)
      return this.walletDetails.WalletAvailableBalance ? this.walletDetails.WalletAvailableBalance : '0';
    return this.hasBalanceToShow ? this.cachedBalance : '0';
  }

  get displayCurrency(): string {
    if (this.walletDetails && this.walletDetails.WalletCurrencyCode)
      return this.walletDetails.WalletCurrencyCode;
    return this.cachedCurrency || this.walletCurrency;
  }

  async getQRCodeInfo() {
    this.isQRLoading = !this.qrCodeImage;

    const qrCodeString = await this.walletProvider.getCustomerQCodeFromStorage();
    if(qrCodeString) this.qrCodeImage = qrCodeString;

    this.isQRLoading = false;

    this.walletProvider.getCustomerQRCode(this.firstRefresh)
      .then((qrCodeString) => {
        if (qrCodeString) {
          this.qrCodeImage = qrCodeString;
        }
      })
      .catch((ex) => {
        LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "Couldn't get QRCode info");
        this.walletProvider.showGenericError();
      })
  }



  onShowOrHideBalance(balanceVisible){
    this.isBalanceHidden = !balanceVisible;
  }

  onSendClick(service){
    if(service.canShowOptions === true){
      const p2pDisabled = service.p2pDisabled;
      this.commonProvider.openSendActionSheet(this.walletDetails, this.location, this.isUserKyced, this.isCustomerIDExpired, p2pDisabled);
    } else {
      this.commonProvider.onSendOrRequestClick(this.walletDetails, this.location);
    }
  }

  async getReceivePage(){
    const liteWalletInflowLimit = this.utilsProvider.getAmountWithCurrency(this.walletProvider.liteWalletInflowLimit, this.walletDetails.WalletCurrencyCode);
    let pageToRender = !this.isCustomerIDExpired ? this.routeProvider.pages.EkycRequiredPage : this.routeProvider.pages.EkycExpiredPage;
    const objOrder = this.orderProvider.getCurrentOrder();

    let isSNWalletNotVerified = false

    if (this.isSN) {
      this.loadingProvider.show();
      const status = await this.walletProvider.getLiteWalletVerificationStatus(this.kycProvider)
      isSNWalletNotVerified = status !== WalletVerificationStatus.Success

      if((status == WalletVerificationStatus.InProgress || status == WalletVerificationStatus.Important) && !this.isCustomerIDExpired) {
        this.routeProvider.openModal(this.routeProvider.pages.OnfidoPendingPage);
        this.loadingProvider.hide();
        return
      }
    }

    if(!this.isUserKyced || this.isCustomerIDExpired || isSNWalletNotVerified ) {
      this.analytics.trackEvent({ eventName: AnalyticsEventType.IdentityVerificationRequired, analyticsData: {
        country: APP_CONFIG.region.defaultCountryFrom,
        destinationCountry: APP_CONFIG.region.defaultCountryFrom,
        location: SegmentLocationNames.InwardRemittance,
        reason: ContactModalReasons.WalletInwardRemittanceConversion,
        vendor: LoggerEvent.Veriff,
        ...(objOrder && objOrder.kycRequirementRule && objOrder.kycRequirementRule.length && { eKYCRule: objOrder.kycRequirementRule }),
        ...(objOrder && objOrder.kycRequirementReasons && objOrder.kycRequirementReasons.length && { eKYCReason: objOrder.kycRequirementReasons })
      } });
      this.routeProvider.openModal(pageToRender,
        {
          msg: this.translate.instant("page.identityVerificationPage.verificationRequiredBody", { liteWalletInflowLimit }),
          primaryButtonAction: () => this.walletProvider.verifyIdFromWallet(this.kycProvider, 'Wallet')
        });
    } else{
      this.routeProvider.openModal(this.routeProvider.pages.WalletReceiveMoneyTrackPage);
    }
    this.loadingProvider.hide();
  }

  openBillPayment(){
    this.analytics.trackEvent({ eventName: AnalyticsEventType.BillPayAccessed, analyticsData: { country: APP_CONFIG.region.defaultCountryFrom } });
    this.routeProvider.openModal(this.routeProvider.pages.WalletBillersPage,{canShowListOfBillers: true});
  }

  async tryAgainActivCreateWallet(){
    this.loadingProvider.show();
    const result = await this.walletProvider.activateWallet("");

    const isActiveWallet : boolean = (result.RetVal === WALLET_ACTIVATION_RETVAL.SUCCESS) ? true : false;
    if(isActiveWallet) {
      await this.loginProvider.getUserAsync(true);
      await this.walletProvider.getWalletDetails(true);
      this.isUserWalletFailedToCreated = (!this.walletProvider.hasWallet() && this.isSN) ? true : false;
    }

    this.loadingProvider.hide();

    this.routeProvider.push(
      this.routeProvider.pages.ModalAlertPage,
      {
        image: isActiveWallet ? 'assets/icons/checkmark_green.svg' : 'assets/imgs/yellow-warning_bg_color.svg',
        imageWithCircle: true,
        title: isActiveWallet ? this.translate.instant('page.registrationFinishPage.registrationCompleteHeader') : this.translate.instant('page.walletHomepage.walletCreationErrorHeader'),
        subtitle: isActiveWallet ? this.translate.instant('page.registrationFinishPage.registrationCompleteContent') : this.translate.instant('page.walletHomepage.walletCreationErrorBody'),
        primaryButtonText: isActiveWallet ? this.translate.instant('global.genericContinueButton') : this.translate.instant('global.gotItButton'),
        showPrimaryButton: true,
        showFullPage: true,
        showRightClose: isActiveWallet ? false : true,
        hideHeader: isActiveWallet ? true : false,
        primaryAction: () => {
          if(isActiveWallet){
            this.routeProvider.replace(this.routeProvider.pages.RegistrationBiometricsPage, {
              analyticsLocation: SegmentLocationNames.Biometrics,
              password: '',
            });
          } else{
            this.routeProvider.popTo(this.routeProvider.pages.WalletHome);
          }
        },
      }, null
    );
  }

  async logWalletAccessedEvent(){
    if(this.walletDetails){
      const availableCards = await this.walletProvider.getWalletAvailableCardTypesAsStringArray();
      const walletInfo = await this.walletProvider.getWalletInfoForAnalytics();
      if(walletInfo && walletInfo.walletBalanceLimit){
        delete walletInfo.walletBalanceLimit;
      }
      let analyticsData = {walletCards: availableCards };
      analyticsData  = { ... walletInfo, ...analyticsData };
      this.analytics.trackEvent({ eventName: AnalyticsEventType.WalletAccessed, analyticsData: { analyticsData } });
    }
  }

  segmentChanged(selectedSeg) {
    if(selectedSeg === 1) {
      this.isWalletToggle = true;
      this.isRemittanceToggle = false;
    } else if (selectedSeg === 2) {
      this.isWalletToggle = false;
      this.isRemittanceToggle = true;
    }

    this.toggleValue = selectedSeg;
  }

  onSelectTransaction(transaction: Transaction, index = null) {
    this.walletProvider.selectTransaction(transaction, index);
  }

  openAirtimeActionSheet(){
    const moreOptions = [
      {
        type: WALLET_SERVICES.AIRTIME_INTNL,
        title: "page.walletHomepage.airtimeInternationalHeader",
        subTitle: "page.walletHomepage.airtimeInternationalBody",
        icon: "/assets/icons/global-smf-gray.svg",
        sortOrder: 1
      },
      {
        type: WALLET_SERVICES.AIRTIME_DOMESTIC,
        title: "page.walletHomepage.airtimeDomesticHeader",
        subTitle: "page.walletHomepage.airtimeDomesticBody",
        icon: "assets/icons/wallet-airtime.svg",
        sortOrder: 2
      }
    ]
    const params = {
      title:this.translate.instant('page.walletHomepage.airtimeTopupLocation'),
      callBack:(service) =>{
        this.onAirtimeOptionsClick(service);
      }, moreOptions
    };
    this.routeProvider.openActionSheet(this.routeProvider.pages.WalletActionsMorePage, params);
  }

  onAirtimeOptionsClick(service){
    switch (service.type) {
      case WALLET_SERVICES.AIRTIME_INTNL:
        this.routeProvider.push(this.routeProvider.pages.MobileTopUpNumberPage, { isInternationalTopUp: true });
        break;
      case WALLET_SERVICES.AIRTIME_DOMESTIC:
        this.routeProvider.push(this.routeProvider.pages.MobileTopUpNumberPage);
        break;
    }
  }

  async openSendMoneyActionClick() {
    const storedOrder = await this.orderProvider.getStoredOrder();
    if (storedOrder && storedOrder.activityDetails && storedOrder.activityDetails.page) {
      if (storedOrder.pendingEKyc || storedOrder.onfidoId) {
        this.loadingProvider.show();
        try {
          this.onfidoProvider.checkId = storedOrder.onfidoId;
          const res = await this.onfidoProvider.getOnfidoStatus(false);
          this.onfidoProvider.handleResult(res, storedOrder, true);
          this.loadingProvider.hide();
          return;
        }
        catch (ex) {
          LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to get Onfido status in send money');
        }
        this.loadingProvider.hide();
      }
      this.routeProvider.openModal(storedOrder.activityDetails.page);
    }
    else {
      this.sendFlowProvider.sendMoneyBtn();
    }
  }

  showSlidesMessages() {
    return this.recentData.slidesMessages && this.recentData.slidesMessages.length > 0 && !this.isLoading;
  }

  touchSlides() {
    this.lockedScroll = true;
  }

  finishTouch() {
    this.lockedScroll = false;
  }

  async getAppMessages() {
    const inAppMessages: InAppMessage[] = await this.iterableInAppProvider.getAppActivityMessages(RmtSlides);
    this.updateSlideMessages(inAppMessages)
  }

  async updateSlideMessages(filterInAppMessages) {
    if (filterInAppMessages) {
      this.hasInAppMessages = filterInAppMessages.length > 0;
      this.inAppMessages = filterInAppMessages;
    }
    let slidesMessages = [];
    slidesMessages = [ ...this.inAppMessages ];

    await this.updateCarouselWithAlert(slidesMessages);
    if (this.checkUpdateSlides(this.recentData.slidesMessages, slidesMessages)) {
      this.recentData.slidesMessages = slidesMessages;
      if (this.slidesMessagesComponent)
        this.slidesMessagesComponent.updateSwiper();
    }
  }

  checkUpdateSlides(initialSlides, slides) {
    // only update slides if data has changed otherwise we trigger the animations all the time
    return (JSON.stringify(initialSlides) !== JSON.stringify(slides));
  }

  async updateCarouselWithAlert(slidesMessages) {
    await this.httpProvider.isTranslationReady();
    const bannerDismissed = await this.walletProvider.getPrepaidCardBannerDismissed();
    const pendingOrderExpiredDismissed = await this.walletProvider.getPendingOrderExpiredDismissed();

    // Load Lite / Full Wallet Verification Slides for SN only for not Expired ID user
    if(this.isSN && !this.isCustomerIDExpired)
        await this.getLiteWalletVerificationSlides(slidesMessages);

    if (!this.isWalletDetailsLoading && this.walletDetails && this.walletDetails.Cards.length != 0 && !this.isUserWalletBlock && this.enableCardIssuance && bannerDismissed != '1' && this.canShowCardsBanner) {
      const prepaidCardMessage = {
        id: SLIDE_TYPE_ID.SLIDE_PREPAID_CARD,
        alertType: ALERT_TYPE.PREPAID_CARD,
        titleKey: 'page.walletHomepage.activateCardMessage',
        title: this.translate.instant('page.walletHomepage.activateCardMessage'),
        pendingLabel: false,
        actionButton: false,
        isClosable: true,
      };
      this.addToSlideMessages(prepaidCardMessage, slidesMessages);
    }

    if (this.isCustomerIDExpired) {
      const CustomerIDInvalidMessage = {
        id: SLIDE_TYPE_ID.SLIDE_CUSTOMER_ID_INVALID,
        alertType: ALERT_TYPE.ALERT_ERROR,
        titleKey: "page.sendFailedPage.iDExpiredHeader",
        title: this.translate.instant("page.sendFailedPage.iDExpiredHeader"),
        pendingLabel: true,
        actionButton: true,
        buttonText: this.translate.instant("page.preLoginPage.updateButton"),
      };
      this.addToSlideMessages(CustomerIDInvalidMessage, slidesMessages);
    }

    if (this.canShowIDPreExpiryBanner) {
      const idPreExpiryMessage = {
        id: SLIDE_TYPE_ID.SLIDE_ID_PRE_EXPIRY,
        alertType: ALERT_TYPE.ALERT_WARNING,
        tagLabel: this.translate.instant('page.ewalletpage.preExpiryBanner.header'),
        titleKey: 'page.ewalletpage.preExpiryBanner.body',
        title: this.translate.instant('page.ewalletpage.preExpiryBanner.body'),
        actionButton: true,
        buttonText: this.translate.instant('page.ewalletpage.preExpiryBanner.button'),
        isClosable: false,
      };
      this.addToSlideMessages(idPreExpiryMessage, slidesMessages);
      if (!this.idPreExpiryBannerTracked) {
        this.idPreExpiryBannerTracked = true;
        this.trackIDPreExpiryBanner(AnalyticsEventType.BannerDisplayed);
      }
    }

    if (this.renderPendingOrderDetails || this.renderIncomingTranx) {
      const pendingTranxSlide = {
        id: SLIDE_TYPE_ID.SLIDE_PENDING_TRANX,
        alertType: this.renderPendingOrderDetails ? ALERT_TYPE.ALERT_WARNING : ALERT_TYPE.ALERT_INFO,
        title: this.renderPendingOrderDetails ? this.pendingOrderMessage : this.translate.instant('page.eWalletPage.incomingPaymentMessage'),
        actionButton: this.renderPendingOrderDetails,
        buttonText: this.renderPendingOrderDetails ? this.translate.instant('page.walletHomepage.PendingTransferMessageButton') : '',
        isClosable: false,
      };
      this.addToSlideMessages(pendingTranxSlide, slidesMessages);
    }

    if (this.isPendingOrderExpired && pendingOrderExpiredDismissed != '1') {
      const expiredOrderSlide = {
        id: SLIDE_TYPE_ID.SLIDE_EXPIRED_ORDER,
        alertType: ALERT_TYPE.ALERT_PENDING,
        title: this.translate.instant('page.eWalletPage.ExpiredPaymentAlert'),
        actionButton: true,
        buttonText: this.translate.instant('page.hubPage.moreInfoButton'),
        isClosable: true,
      };
      this.addToSlideMessages(expiredOrderSlide, slidesMessages);
    }
  }

  async getLiteWalletVerificationSlides(slidesMessages) {
    if (!this.walletDetails) return

    const status = await this.walletProvider.getLiteWalletVerificationStatus(this.kycProvider)
    const slideConfig = this.getLiteWalletVerificationSlideConfig(status)
    // check if the status is in_progress then call show RmtPopupComponent and contintue

    this.handleWalletVerificationStatusChange(status)

    // Dont continue when the status is success/verified status as there is slide for this status
    if(status == WalletVerificationStatus.Success) {
      return
    }

    // passing the slider's details dynamically to the addToSlideMessages function
    const slideMessage = {
      id: slideConfig.slideId,
      alertType: slideConfig.alertType,
      title: slideConfig.title,
      tagLabel: slideConfig.tagLabel,
      actionButton: true,
      isClosable: true,
      buttonText: slideConfig.buttonText,
    };
    this.addToSlideMessages(slideMessage, slidesMessages);
  }

  async handleWalletVerificationStatusChange(status: WalletVerificationStatus) {
    const lastStatus = await this.storageProvider.get(StorageType.WalletVerificationStatus)

    if (lastStatus === status) return

    await this.storageProvider.set(StorageType.WalletVerificationStatus, status)

    // React only to specific statuses
    if (status === WalletVerificationStatus.Success) {
      RmtSnackbarComponent.present(
        this.translate.instant('page.eWalletPage.idVerificationSuccessAlert')
      )
    }
  }

  getLiteWalletVerificationSlideConfig(status: WalletVerificationStatus) {
    switch (status) {
      case WalletVerificationStatus.InProgress:
        return {
          slideId: SLIDE_TYPE_ID.SLIDE_INPROGRESS_LITE_WALLET,
          alertType: ALERT_TYPE.ALERT_INFO,
          tagLabel: this.translate.instant(
            'page.eWalletPage.idVerificationBanner.header'
          ),
          title: this.translate.instant(
            'page.eWalletPage.idVerificationBanner.body'
          ),
          buttonText: '',
        }

      case WalletVerificationStatus.Important:
        return {
          slideId: SLIDE_TYPE_ID.SLIDE_IMPORTANT_LITE_WALLET,
          alertType: ALERT_TYPE.ALERT_IMPORTANT,
          tagLabel: this.translate.instant(
            'page.eWalletPage.idVerificationExpiredBanner.header'
          ),
          title: this.translate.instant(
            'page.eWalletPage.idVerificationExpiredBanner.body'
          ),
          buttonText: this.translate.instant(
            'page.eWalletPage.idVerificationExpiredBanner.help'
          ),
        }

      case WalletVerificationStatus.Pending:
      default:
        return {
          slideId: SLIDE_TYPE_ID.SLIDE_PENDING_LITE_WALLET,
          alertType: ALERT_TYPE.ALERT_INFO,
          tagLabel: this.translate.instant(
            'page.eWalletPage.idRequiredBanner.header'
          ),
          title: this.translate.instant(
            'page.eWalletPage.idRequiredBanner.body'
          ),
          buttonText: this.translate.instant(
            'page.eWalletPage.idRequiredBanner.cta'
          ),
        }
    }
  }


  async addToSlideMessages(newSlideMessage: any, slidesMessages) {
    const existingItem = slidesMessages.find(item => item.id === newSlideMessage.id);

    if (!existingItem) {
      slidesMessages.unshift(newSlideMessage);
    } else if (existingItem && existingItem.title !== newSlideMessage.title) {
      const pos = slidesMessages.map(item => item.id).indexOf(newSlideMessage.id);
      slidesMessages[pos] = newSlideMessage;
    } else {
      LoggerProvider.log(this, LoggerLevel.Info, LoggerEvent.SlideExists, `Item with id ${newSlideMessage.id} already exists.`);
    }
  }

  clickCloseSlide(slide: any) {
    if (slide.id === SLIDE_TYPE_ID.SLIDE_PREPAID_CARD) {
      this.walletProvider.setPrepaidCardBannerDismissed();
      return;
    }
    if (slide.id === SLIDE_TYPE_ID.SLIDE_EXPIRED_ORDER) {
      this.walletProvider.setPendingOrderExpiredDismissed();
      return;
    }
    if(slide.isClosable && slide.closeAction) {
      slide.closeAction();
    }
  }

  // Will have more slides/campaigns in the future, hence keeping switch cases
  onClickSlide(slide: any) {
    if (slide.id) {
      switch (slide.id) {
        case SLIDE_TYPE_ID.SLIDE_PREPAID_CARD:
          this.onCardBannerSelected();
          break;
        case SLIDE_TYPE_ID.SLIDE_IMPORTANT_LITE_WALLET:
          this.helpProvider.openHelp();
          break;
        case SLIDE_TYPE_ID.SLIDE_PENDING_LITE_WALLET:
          this.walletProvider.onClickUpgradeWalletLimit(this.kycProvider);
          break;
        case SLIDE_TYPE_ID.SLIDE_CUSTOMER_ID_INVALID:
          this.updateExpiredID();
          break;
        case SLIDE_TYPE_ID.SLIDE_ID_PRE_EXPIRY:
          this.trackIDPreExpiryBanner(AnalyticsEventType.BannerCtaClicked);
          this.updateExpiredID();
          break;
        case SLIDE_TYPE_ID.SLIDE_PENDING_TRANX:
          if (this.renderPendingOrderDetails) {
            this.walletProvider.onGetPendingTransferClick(this.pendingOrderEkycTitle);
          }
          break;
        case SLIDE_TYPE_ID.SLIDE_EXPIRED_ORDER:
          this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, {
            title: this.translate.instant('page.eWalletPage.ExpiredPaymentTitle'),
            subtitleInnerHtml: this.translate.instant('page.eWalletPage.ExpiredPaymentBody').replaceAll('\\n', '\n'),
            primaryButtonText: this.translate.instant('global.gotItButton'),
            showPrimaryButton: true,
            isModal: true,
            hideHeader: true,
          });
          break;
      }
    }
  }

  fillPendingTranxAlerts() {
    this.pendingTranxAlerts = [];
    // Pending order details or incoming transaction after ekyc done
    if (this.renderPendingOrderDetails || this.renderIncomingTranx) {
      this.pendingTranxAlerts.push({
        show: true,
        additionalStyle: this.alertStyles,
        alertText: this.renderPendingOrderDetails ? this.pendingOrderMessage : this.translate.instant('page.eWalletPage.incomingPaymentMessage'),
        includeButton: this.renderPendingOrderDetails,
        buttonText: this.renderPendingOrderDetails ? this.translate.instant('page.walletHomepage.PendingTransferMessageButton') : '',
        clickButton: this.renderPendingOrderDetails ? () => this.walletProvider.onGetPendingTransferClick(this.pendingOrderEkycTitle) : null,
        showClose: false,
        type: this.renderPendingOrderDetails ? ALERT_TYPE.ALERT_WARNING : ALERT_TYPE.ALERT_INFO
      });
    }

    // Pending order expired alert
    if (this.isPendingOrderExpired) {
      this.pendingTranxAlerts.push({
        show: true,
        additionalStyle: this.alertStyles,
        alertText: this.translate.instant('page.eWalletPage.ExpiredPaymentAlert'),
        includeButton: true,
        buttonText: this.translate.instant('page.hubPage.moreInfoButton'),
        showClose: false,
        type: ALERT_TYPE.ALERT_PENDING,
        clickButton: () => this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, {
          title: this.translate.instant('page.eWalletPage.ExpiredPaymentTitle'),
          subtitleInnerHtml: this.translate.instant('page.eWalletPage.ExpiredPaymentBody').replaceAll('\\n', '\n'),
          primaryButtonText: this.translate.instant('global.gotItButton'),
          showPrimaryButton: true,
          isModal: true,
          hideHeader: true,
        })
      });
    }
  }

  trackIDPreExpiryBanner(eventName: AnalyticsEventType) {
    this.analytics.trackEvent({
      eventName,
      analyticsData: {
        bannerType: BannerType.IDExpiringSoon,
        alertName: BannerType.IDExpiringSoon,
        campaignId: ID_PRE_EXPIRY_BANNER_CAMPAIGN_ID,
        carouselCardType: CarouselCardType.Kyc,
        location: SegmentLocationNames.Home
      }
    });
  }

  trackDeposit(method: string) {
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.WalletDepositStarted,
      analyticsData: { method }
    });
  }

  async rmtViewDidReEnter() {
    // update the status for expired ID
    const wasExpired = this.isCustomerIDExpired;
    const wasExpiringSoon = this.isCustomerIDExpiringSoon;
    await this.setCustomerIDExpiryStatus();
    if (this.isCustomerIDExpired !== wasExpired || this.isCustomerIDExpiringSoon !== wasExpiringSoon) {
      await this.updateSlideMessages(null);
    }
  }

  async setCustomerIDExpiryStatus() {
    // After an eKYC the cached profile can still have the old ID
    // thus force refresh profile will help to update the status
    if (await this.loginProvider.isCustomerIDInvalid()) {
      await Promise.race([this.loginProvider.getUserAsync(true), new Promise(resolve => setTimeout(resolve, 5000))]);
    }
    const [isCustomerIDInvalid, isCustomerIDExpiringSoon] = await Promise.all([
      this.loginProvider.isCustomerIDInvalid(),
      this.loginProvider.isCustomerIDExpiringSoon(ID_PRE_EXPIRY_BANNER_DAYS)
    ]);
    this.isCustomerIDExpired = isCustomerIDInvalid;
    this.isCustomerIDExpiringSoon = isCustomerIDExpiringSoon;
  }

  get canShowIDPreExpiryBanner(): boolean {
    const region = APP_CONFIG.region.region;
    return (region === Region.SN || region === Region.MY)
      && this.isCustomerIDExpiringSoon;
  }

  async updateExpiredID() {
    if (this.loginProvider.isUserFraudBlocked())
      return this.utilsProvider.redirectToRestrictedTransfers();

    const customer = await this.customerProvider.getCustomer();

    if (this.onfidoProvider.requireUpdateIdOnStore(customer))
      this.routeProvider.openModal(
        this.routeProvider.pages.UpdateIdOnStorePage
      );
    else {
      this.loadingProvider.show();
      await this.customerProvider.navigateIDDetails(this.onfidoProvider, true, SegmentLocationNames.Carousel);
      this.loadingProvider.hide();
    }
  }

  async checkReferAFriendAvailability() {
    try {
      const referAFriendSetting = await UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.ShowReferAFriendCTA);
      if (referAFriendSetting) {
        await this.loadReferralReward();
        this.referAFriendAvailable = true;
      } else {
        this.referAFriendAvailable = false;
      }
    } catch (exception) {
      this.referAFriendAvailable = false;
      LoggerProvider.exception(this, exception, LoggerEvent.ReferaFriend, 'Failed to check refer a friend availability on wallet home');
    }
  }

  async onReferAFriend() {
    this.routeProvider.openModal(this.routeProvider.pages.ReferAFriendNewPage, { analyticsLocation: SegmentLocationNames.Wallet });
  }

  private async loadReferralReward() {
    try {
      const response = await this.socialProvider.getReferralCodeNew();
      if (response && response.Value && response.Value.ReferralAmount !== null && response.Value.ReferralAmount !== undefined) {
        const symbol = getCurrencySymbol(APP_CONFIG.region.defaultCurrencyFrom, 'narrow');
        this.referralReward = `${symbol}${response.Value.ReferralAmount}`;
      } else {
        this.referralReward = '';
      }
    } catch (exception) {
      this.referralReward = '';
      LoggerProvider.exception(this, exception, LoggerEvent.ReferaFriend, 'Failed to load referral reward for wallet home pill');
    }
  }

  onHelp = () => {
    this.walletProvider.openHelpActionSheet();
  }

}



// WEBPACK FOOTER //
// ./src/pages/wallet-home/wallet-home.ts